import { makeStyles } from '@material-ui/styles'
import { useAppSelector } from 'app/store'
import FontAwesomeIcon from 'core/components/FontAwesomeIcon'
import SimpleLink from 'core/components/SimpleLink'
import Text from 'core/elements/Text'
import Tooltip from 'core/elements/tooltip/Tooltip'
import type Theme from 'core/themes/model'
import { routeManager } from 'core/utils/routes'
import {
  clustersWithUnassignedFdmHostsSelector,
  stretchedClustersByClusterSelector,
} from '../stretched-clusters/selectors'

const useStyles = makeStyles<Theme>((theme) => ({
  warningIcon: {
    color: theme.palette.warning.main,
  },
}))

const StretchedClustersCellComponent = ({ item }) => {
  const classes = useStyles()
  const stretchedClustersByCluster = useAppSelector(stretchedClustersByClusterSelector)
  const clustersWithUnassignedFdmHosts = useAppSelector(clustersWithUnassignedFdmHostsSelector)
  const pair = stretchedClustersByCluster[item?.name]
  const hasUnassigned = clustersWithUnassignedFdmHosts.has(item?.name)

  if (!pair?.domainA && !pair?.domainB) {
    return <Text variant="body2">—</Text>
  }

  return (
    <>
      {pair?.domainA && (
        <SimpleLink
          src={routeManager.routes.openstack.stretchedClusterDetails.path({
            id: pair.domainA.id,
            tab: 'overview',
          })}
        >
          1. {pair.domainA.name}
        </SimpleLink>
      )}
      <br />
      {pair?.domainB && (
        <SimpleLink
          src={routeManager.routes.openstack.stretchedClusterDetails.path({
            id: pair.domainB.id,
            tab: 'overview',
          })}
        >
          2. {pair.domainB.name}
        </SimpleLink>
      )}
      {hasUnassigned && (
        <Tooltip message="One or more hosts in this cluster are not assigned to a failure domain.">
          Unassigned Hosts{' '}
          <FontAwesomeIcon className={classes.warningIcon} solid>
            triangle-exclamation
          </FontAwesomeIcon>
        </Tooltip>
      )}
    </>
  )
}

export default StretchedClustersCellComponent
